import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';

import { ComparisonMethod } from './types';

type FetchComparisonMethodsParams = { version_1: string; version_2: string; system_model: string };

const fetchComparisonMethods = async (params: FetchComparisonMethodsParams) => {
  const { data } = await api.get(`/spold/comparison/methods`, { params });

  return data;
};

const useComparisonMethods = (version1?: string, version2?: string, systemModel?: string) =>
  useQuery<ComparisonMethod[], AxiosError>({
    queryKey: ['comparisonMethods', version1, version2, systemModel],
    queryFn: () =>
      fetchComparisonMethods({
        version_1: version1 as string,
        version_2: version2 as string,
        system_model: systemModel as string,
      }),
    enabled: Boolean(version1 && version2 && systemModel),
    staleTime: Infinity,
  });

export default useComparisonMethods;
